import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../../firebase/config"; // adjust path to your firebase config
import { useNavigate } from "react-router-dom";
import logoTitle from "../../../assets/images/Logos/kole-medical-wordmark.svg";
import "../../../styles/AuthStyles/ForgotPassword.css";

export default function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    if (!email.trim()) return "Email is required.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return "Please enter a valid email.";
    return "";
  };

  const handleSubmit = async () => {
    setError("");
    const validationError = validate();
    if (validationError) { setError(validationError); return; }

    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(true);
    } catch (err: any) {
      // Firebase error codes
      switch (err.code) {
        case "auth/user-not-found":
          setError("No account found with this email address.");
          break;
        case "auth/invalid-email":
          setError("Please enter a valid email address.");
          break;
        case "auth/too-many-requests":
          setError("Too many attempts. Please try again later.");
          break;
        default:
          setError("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // ── SUCCESS SCREEN ──────────────────────────────────────────────────────────
  if (success) {
    return (
      <section className="forgotContainer">
        <div className="forgotCard success">

          <div className="successIcon">✉️</div>

          <h3>Check Your Email</h3>
          <p className="successDesc">
            We sent a password reset link to <strong>{email}</strong>.
            Check your inbox and follow the instructions.
          </p>

          <p className="successNote">
            Didn't receive it? Check your spam folder or{" "}
            <button
              className="resendBtn"
              onClick={() => setSuccess(false)}
            >
              try again
            </button>
            .
          </p>

          <button
            className="btnPrimary"
            onClick={() => navigate("/login")}
          >
            Back to Login
          </button>

        </div>
      </section>
    );
  }

  // ── MAIN FORM ───────────────────────────────────────────────────────────────
  return (
    <section className="forgotContainer">
      <div className="forgotCard">

        {/* Logo */}
        <div className="forgotLogo">
          <img src={logoTitle} alt="Kole Medical" width={174} height={34} />
          <h3>Forgot Password</h3>
          <p>Enter your email and we'll send you a reset link.</p>
        </div>

        {/* Error banner */}
        {error && (
          <div className="error-banner">
            ⚠ {error}
          </div>
        )}

        {/* Email input */}
        <div className="forgotField">
          <label htmlFor="reset-email">Email Address</label>
          <input
            id="reset-email"
            type="email"
            placeholder="you@example.co.za"
            value={email}
            onChange={e => { setEmail(e.target.value); setError(""); }}
            className={error ? "inputError" : ""}
          />
        </div>

        {/* Submit */}
        <button
          className="btnPrimary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>

        {/* Back to login */}
        <a className="backLink" href="/login">
          ← Back to Login
        </a>

      </div>
    </section>
  );
}